module.exports = __webpack_public_path__ + "static/media/Avfall.8f55ea39.mp3";